import { useLocation } from "react-router-dom";
import { Phone, FileText } from "lucide-react";

export default function MobileBar() {
  const { pathname } = useLocation();
  // Never show on the admin area. The /claim page is a standalone static page
  // (no React), so this bar can never appear there.
  if (pathname.startsWith("/admin")) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-mist shadow-[0_-4px_12px_rgba(23,25,28,0.08)] p-3 flex gap-3 md:hidden"
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
      data-testid="mobile-bottom-bar"
    >
      <a
        href="tel:1800957474"
        className="flex-1 inline-flex items-center justify-center gap-2 min-h-[48px] px-4 bg-mist text-ink font-saira font-semibold rounded"
        data-testid="mobile-bar-call-button"
      >
        <Phone className="size-5" aria-hidden="true" />
        Call us
      </a>
      <a
        href="/claim"
        className="flex-1 inline-flex items-center justify-center gap-2 min-h-[48px] px-4 bg-ink text-white font-saira font-semibold rounded"
        data-testid="mobile-bar-start-claim-button"
      >
        <FileText className="size-5" aria-hidden="true" />
        Start claim
      </a>
    </div>
  );
}
